import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Plan } from 'app/models/plan';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PlanService {

  base_path = 'https://app.titv-store-api.com/';

  constructor(private http: HttpClient) { }
  private refreshData = new Subject<void>();
  get refreshNedeed() {
    return this.refreshData;
  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  createPlan(item ,idPlan): Observable<Plan> {
    // let headers=new HttpHeaders({'Authorization':'Bearer '+sessionStorage.TOKEN_KEY});
    return <Observable<Plan>>this.http
      .post<Plan>(this.base_path + 'projets/piece/plan/add' + '/'+ idPlan
      , JSON.stringify(item), this.httpOptions)
      .pipe(
        tap(() => {
          this.refreshNedeed.next();
        })
      );

  }

  // Get single Plan data by ID
  getPlan(id): Observable<Plan> {
    return <Observable<Plan>>this.http
      .get(this.base_path + 'projets/piece/plan' + '/' + id)


  }

  // Get Plans data
  getListPlan(): Observable<Plan> {
    return <Observable<Plan>>this.http
      .get<Plan>(this.base_path + 'projets/piece/plan/all')
  }
  
  // Update item by id
  updatePlan(id, item): Observable<Plan> {
    // let headers=new HttpHeaders({'Authorization':'Bearer '+sessionStorage.TOKEN_KEY});
    return <Observable<Plan>>this.http
      .put<Plan>(this.base_path + 'projets/piece/plan/update' + '/' + id, JSON.stringify(item), this.httpOptions)
      .pipe(
        tap(() => {
          this.refreshNedeed.next();
        })
      );

  }

  // Delete item by id
  deletePlan(id) {
    // let headers=new HttpHeaders({'Authorization':'Bearer '+sessionStorage.TOKEN_KEY});
    return this.http
      .delete<Plan>(this.base_path + 'projets/piece/plan/delete' + '/' + id, this.httpOptions)
      .pipe(
        tap(() => {
          this.refreshNedeed.next();
        })
      );

  }
}
